import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  standalone: true,
  name: 'tiFnPipe',
})
export class FnPipe implements PipeTransform {
  transform(value: any, fn: Function, ...args) {
    return fn(value, ...args);
  }
}
